import React from 'react';
import { useIntl } from 'react-intl';
import { formatMoney } from 'util/currency';
import { types as sdkTypes } from 'util/sdkLoader';
import AddonPill from '../../../common/components/AddonPill/AddonPill';
import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;
const ADDON_PREFIX = 'line-item/addon-';

const extractAddonId = (code) => {
  if (!code.startsWith(ADDON_PREFIX)) return null;
  return code.slice(ADDON_PREFIX.length, ADDON_PREFIX.length + 36);
};

const LineItemAddonsMaybe = ({ lineItems, listing, userRole }) => {
  const intl = useIntl();
  const currency = listing?.attributes?.price?.currency ?? 'GBP';
  const addonDefs = listing?.attributes?.publicData?.addons || [];

  const addonItems = lineItems.filter(
    item =>
      !item.reversal &&
      item.code.startsWith(ADDON_PREFIX) &&
      item.includeFor.includes(userRole)
  );

  if (!addonItems.length) return null;

  // Aggregate multiple line items for the same addon (e.g. across PayAsYouGo sessions)
  const totals = {};
  addonItems.forEach(item => {
    const addonId = extractAddonId(item.code);
    if (!addonId) return;
    if (!totals[addonId]) totals[addonId] = { amount: 0, quantity: 0 };
    totals[addonId].amount += item.lineTotal.amount;
    totals[addonId].quantity += Number(item.quantity ?? 1);
  });

  const rows = Object.entries(totals)
    .map(([addonId, { amount, quantity }]) => {
      const def = addonDefs.find(a => a.id === addonId);
      if (!def) return null;
      const formatted = formatMoney(intl, new Money(amount, currency));
      return { addonId, def, formatted, quantity };
    })
    .filter(Boolean);

  if (!rows.length) return null;

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.addonLineItems}>
        {rows.map(({ addonId, def, formatted, quantity }) => (
          <div key={addonId} className={css.lineItem}>
            <AddonPill addon={def} currency={currency} quantity={quantity > 1 ? quantity : undefined} />
            <span className={css.itemValue}>{formatted}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default LineItemAddonsMaybe;
